import { createValidator } from "not-valid";

export const purchaseOrderNumberValidator = createValidator<string>(
    value => !value || value.length >= 4 && value.length <= 25,
    "Purchase Order Number should have at-least 4 and up to 25 characters"
);
